import React from "react";

const NoItemsMessage = ({ onClearFilters }) => {
  return (
    <div className="no-items-message">
      <h3>No items found</h3>
      <p>No matching items found. Filters will be cleared automatically.</p>
      <button className="clear-filters-btn" onClick={onClearFilters}>
        Clear All Filters Now
      </button>
    </div>
  );
};

export default NoItemsMessage;